import Vue from 'vue'
import VueToastr from './components/VueToastr.vue'
Vue.use(VueToastr)
